import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';
import { getBrutalistStyles } from '../styles/brutalist';

const BrutalistNavigation = () => {
  const { isDarkMode } = useTheme();
  const { isAuthenticated, school } = useAuth();
  const brutalistStyles = getBrutalistStyles(isDarkMode);
  const location = useLocation();
  const navigate = useNavigate();

  // Handle school access link click
  const handleSchoolAccessClick = (e) => {
    // If a school is logged in, redirect to dashboard
    if (isAuthenticated && school) {
      e.preventDefault();
      navigate('/dashboard');
    }
    // Otherwise, continue to the normal link destination
  };

  // Mapeo de rutas a nombres amigables
  const pathNames = {
    '': 'Inicio',
    'registrar-nueva-autoescuela': 'Registrar Autoescuela',
    'iniciar-sesion': 'Iniciar Sesión',
    'acceso-autoescuela': 'Acceso Autoescuelas',
    'dashboard': 'Panel de Control'
  };

  // Construir el breadcrumb basado en la ruta actual
  const paths = location.pathname.split('/').filter(Boolean);
  const breadcrumbs = paths.map((path, index) => {
    const url = `/${paths.slice(0, index + 1).join('/')}`;
    return {
      name: pathNames[path] || path,
      url
    };
  });

  return (
    <nav style={brutalistStyles.brutalistNavigation}>
      <Link to="/" style={brutalistStyles.brutalistHomeButton}>
        <svg 
          width="20" 
          height="20" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        >
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
          <polyline points="9 22 9 12 15 12 15 22"></polyline>
        </svg>
        Inicio
      </Link>

      {breadcrumbs.length > 0 && (
        <div style={brutalistStyles.brutalistBreadcrumb}>
          {breadcrumbs.map((breadcrumb, index) => (
            <React.Fragment key={breadcrumb.url}>
              {index > 0 && (
                <span style={brutalistStyles.brutalistBreadcrumbSeparator}>
                  /
                </span>
              )}
              <Link
                to={breadcrumb.url}
                style={brutalistStyles.brutalistBreadcrumbItem}
                onClick={breadcrumb.url === '/acceso-autoescuela' ? handleSchoolAccessClick : undefined}
              >
                {breadcrumb.name}
              </Link>
            </React.Fragment>
          ))}
        </div>
      )}
    </nav>
  );
};

export default BrutalistNavigation;